import { ContactViewModel, TagAlertViewModel } from '@ViewModels';
import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { SearchIcon } from '../../../svgs/icons/SearchIcon';
import { EmailGuideTag } from '../EmailGuideTag';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	contactsWithKitsDue?: ContactViewModel[];
	onAdvancedSearchButtonClicked?(): void;
	onSelectContactsWithKeepInTouchedDue?(): void;
	onTagAlertSelected?(tagAlert: TagAlertViewModel): void;
	onTagSelected?(tag: string): void;
	recommendedTags?: string[];
	onRenderAdvancedNode?(): React.ReactNode;
	tagAlerts?: TagAlertViewModel[];
}

interface IState {
	selectedKits?: boolean;
	selectedTag?: string;
	selectedTagAlert?: TagAlertViewModel;
}

class _GroupEmailTagSelect extends React.Component<IProps, IState> {
	private mMounted: boolean;
	public readonly state: IState = {};

	constructor(props: IProps) {
		super(props);
	}

	public componentDidMount() {
		this.mMounted = true;
	}

	public componentWillUnmount() {
		this.mMounted = false;
	}

	public render() {
		const {
			className,
			tagAlerts,
			contactsWithKitsDue,
			recommendedTags,
			onAdvancedSearchButtonClicked,
			onRenderAdvancedNode,
		} = this.props;
		const { selectedTag, selectedTagAlert, selectedKits } = this.state;
		return (
			<div className={`${css(styleSheet.container)} group-email-tag-select ${className || ''}`}>
				<div className={css(styleSheet.body)}>
					{!!recommendedTags && recommendedTags.length > 0 && (
						<div className={css(styleSheet.section)}>
							<div className={css(styleSheet.sectionTitle)}>Send emails to contacts that match the tag:</div>
							<div className={css(styleSheet.recommendedTagsBody)}>
								<div className={css(styleSheet.tagsContainer)}>
									{(recommendedTags || []).map((x, i) => {
										return (
											<EmailGuideTag
												className={css(styleSheet.tag)}
												isSelected={!!selectedTag && x === selectedTag}
												key={`${x}-${i}`}
												onClick={this.onTagSelected(x)}
												value={x}
											/>
										);
									})}
								</div>
							</div>
						</div>
					)}
					{((!!tagAlerts && tagAlerts.length > 0) || (!!contactsWithKitsDue && contactsWithKitsDue.length > 0)) && (
						<div className={css(styleSheet.section)}>
							<div className={css(styleSheet.sectionTitle)}>Send emails to contacts that have alerts due:</div>
							<div className={css(styleSheet.alertsBody)}>
								<div className={css(styleSheet.tagsContainer)}>
									{(tagAlerts || []).map((x, i) => {
										return (
											<EmailGuideTag
												className={css(styleSheet.tag)}
												isSelected={!!selectedTagAlert && selectedTagAlert === x}
												key={x.id || `${x.tagValue}-${i}`}
												onClick={this.onTagAlertSelected(x)}
												tagAlert={x}
												value={x.tagValue}
											/>
										);
									})}
									{!!contactsWithKitsDue && contactsWithKitsDue.length > 0 && (
										<EmailGuideTag
											className={css(styleSheet.tag)}
											contactsWithKitsDue={contactsWithKitsDue}
											isSelected={!!selectedKits}
											key={`kits-tag-${contactsWithKitsDue.length}`}
											onClick={this.onSelectContactsWithKeepInTouchedDue}
											value='Keep in Touches'
										/>
									)}
								</div>
							</div>
						</div>
					)}
					<div className={css(styleSheet.section)}>
						<div className={css(styleSheet.sectionTitle)}>Don&apos;t see what you are looking for?</div>
						{onRenderAdvancedNode ? (
							onRenderAdvancedNode()
						) : (
							<button className={css(styleSheet.advancedSearchButton)} onClick={onAdvancedSearchButtonClicked}>
								<SearchIcon />
								<span>Advanced Search</span>
							</button>
						)}
					</div>
				</div>
			</div>
		);
	}

	private onTagSelected = (tag: string) => () => {
		const { selectedTag, selectedTagAlert, selectedKits } = this.state;
		if (!selectedTag && !selectedTagAlert && !selectedKits) {
			this.setState(
				{
					selectedTag: tag,
				},
				() => {
					setTimeout(() => {
						const { onTagSelected } = this.props;
						if (!!this.mMounted && !!onTagSelected) {
							onTagSelected(tag);
						}
					}, 200);
				}
			);
		}
	};

	private onTagAlertSelected = (tagAlert: TagAlertViewModel) => () => {
		const { selectedTag, selectedTagAlert, selectedKits } = this.state;
		if (!selectedTag && !selectedTagAlert && !selectedKits) {
			this.setState(
				{
					selectedTagAlert: tagAlert,
				},
				() => {
					setTimeout(() => {
						const { onTagAlertSelected } = this.props;
						if (!!this.mMounted && !!onTagAlertSelected) {
							onTagAlertSelected(tagAlert);
						}
					}, 200);
				}
			);
		}
	};

	private onSelectContactsWithKeepInTouchedDue = () => {
		const { selectedTag, selectedTagAlert, selectedKits } = this.state;
		if (!selectedTag && !selectedTagAlert && !selectedKits) {
			this.setState(
				{
					selectedKits: true,
				},
				() => {
					setTimeout(() => {
						const { onSelectContactsWithKeepInTouchedDue } = this.props;
						if (!!this.mMounted && !!onSelectContactsWithKeepInTouchedDue) {
							onSelectContactsWithKeepInTouchedDue();
						}
					}, 200);
				}
			);
		}
	};
}

export const GroupEmailTagSelect = observer(_GroupEmailTagSelect);
